import { render, staticRenderFns } from "./_integralDetail.vue?vue&type=template&id=3e36af5a&scoped=true"
import script from "./_integralDetail.vue?vue&type=script&lang=js"
export * from "./_integralDetail.vue?vue&type=script&lang=js"
import style0 from "./_integralDetail.vue?vue&type=style&index=0&id=3e36af5a&prod&lang=scss&scoped=true"
import style1 from "./_integralDetail.vue?vue&type=style&index=1&id=3e36af5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36af5a",
  null
  
)

export default component.exports